// com.tamr.recipe.RecipeConstants

export const RECIPE_INPUTS_KEY = 'recipeInputs';
